// TODO: frames animation
import type { AccentHue } from "@repo/fika-design-system/color"
import type { UploadFolder } from "@repo/fika-shared/src/upload-folder.js"
import { uploadImage } from "@/data/upload-image"
import { FileUpload } from "./file-upload"
import { backgroundClass } from "./file-upload.css"

type Props = {
  onUpload: (src: string | null, optimstic: boolean) => void
  text?: string
  imageSrc?: string | null
  hue: AccentHue
  imgClass?: string
  uploadFolder: UploadFolder
  variant?: "default" | "profile"
}

export function ImageUpload(props: Props) {
  async function onUpload(files: File[]) {
    const file = files[0]
    if (!file) {
      props.onUpload(null, false)
      return
    }

    const dataUrl = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(reader.result as string)
      reader.onerror = reject
      reader.readAsDataURL(file)
    })
    props.onUpload(dataUrl, true)

    try {
      const url = await uploadImage(file, props.uploadFolder)
      const img = new Image()
      img.onload = () => {
        if (props.imageSrc === dataUrl) {
          props.onUpload(url, false)
        }
      }
      img.onerror = () => {
        if (props.imageSrc === dataUrl) {
          props.onUpload(null, false)
        }
      }
      img.src = url
    } catch (error) {
      console.error("failed to upload image:", error)
      if (props.imageSrc === dataUrl) {
        props.onUpload(null, false)
      }
    }
  }

  return (
    <FileUpload
      onUpload={onUpload}
      text={props.text}
      hue={props.hue}
      accept="image/*"
      iconName="image-up"
      hasFile={!!props.imageSrc}
      variant={props.variant}
    >
      <img
        src={props.imageSrc!}
        class={[backgroundClass, props.imgClass].filter(t => !!t).join(" ")}
        alt=""
      />
    </FileUpload>
  )
}
